module.exports = __webpack_public_path__ + "img/Ausgangspunkt.c1c82122.svg";